module.exports = __webpack_public_path__ + "static/media/file.d2b0c4c4.svg";